export default "__VITE_ASSET__D9PwyBpp__"